import styled from 'styled-components';
import { EmailFirstTextFormInput } from '../text';

export const StyledEmailFirstTextFormInput = styled(EmailFirstTextFormInput)`
    .sb-field__input {
        padding-right: 4rem;
    }
`;
